// extracted by mini-css-extract-plugin
export default {"gamebox_body":"gamebox_gamebox_body__EyLyt","title":"gamebox_title__Sfbu2","content":"gamebox_content__SbKnX"};